<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='theSelectProjectId' v-if="theUserProject==0" clearable size="small" @change="theSelectProjectChange" placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-input
          v-model="getSysRulePointsDesList_data.yutName"
          placeholder="请输入积分规则描述名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getSysRulePointsDesList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button
          v-if="addSysRulePointsDes && theSelectProjectId"
          @click="toAddSysRulePointsDes"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加积分规则描述
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getSysRulePointsDesList'
      api='getSysRulePointsDesList'
      updateapi='updateSysRulePointsDes'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addSysRulePointsDes:    [ "新增积分规则描述信息", "el-icon-circle-plus" ],
        updateSysRulePointsDes: [ "修改积分规则描述信息", "el-icon-edit-outline"],
        $succeed$: getSysRulePointsDesList
      }'
      @close='$form("addSysRulePointsDes","reset")' 
      @opened="$form('addSysRuleIncomeDes','ifshow'),Myformdata.projectId=theSelectProjectId">
      <hide slot='srpdId' />
      <hide slot='projectId' />
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      srpdId: null,
      theSelectProjectId: "",
      theUserProject: "",
      tableColums_getSysRulePointsDesList: {
        $selection: false,

        srpdDes: '规则描述',
        srpdOrder: '排序',
        createtime: '创建时间',

        $operation: [
          '操作', 200,
          this.updateSysRulePointsDes &&`@text: 编辑#success
           @click: $form("updateSysRulePointsDes",$row)
          `,
          this.deleteSysRulePointsDes && `@text: 删除#danger
           @click: _confirm('确定要删除该积分规则描述吗?')
                   .trigger('deleteSysRulePointsDes',{srpdId:$row.srpdId})
                   .trigger('getSysRulePointsDesList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {
    toAddSysRulePointsDes(){
      this.$form('addSysRulePointsDes');
    },
    theSelectProjectChange(e){
      this.theSelectProjectId=e;
      this.getSysRulePointsDesList({projectId:this.theSelectProjectId});
    },
  },

  created() {
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject!=0){
      this.theSelectProjectId=this.theUserProject;
    }
    this.getSysRulePointsDesList({projectId:this.theSelectProjectId});
    this.getProjectList({ pageSize: 0 });
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/rule/PointsRuleDesManage.vue